import React, { useState, useEffect } from 'react';
import { Typography, Button } from 'antd';
import i18n from "i18next";

const { Paragraph } = Typography;

/**
 * 
 */
export default function ClampLines({ text, rows = 3 }) {
  const [expanded, setExpanded] = useState(false);
  
  //Скрыть мерцание текста (при первом отображении, если необходимо сворачивания) до готовности - костыль, но рабочий!
  const [ready, setReady] = useState(false);
  useEffect(() => { requestAnimationFrame(() => setReady(true)); }, []);

  return (
    <Paragraph 
      style={{ marginBottom: 0, visibility: ready ? "visible" : "hidden" }}
      onClick={(e) => {
        if (e.target instanceof Element && (e.target.closest('.ant-typography-expand') || e.target.closest('.ant-typography-collapse'))) {
          e.stopPropagation();
        }
      }}
      ellipsis={{
        rows,
        expandable: 'collapsible',
        expanded,
        onExpand: (e, info) => setExpanded(info.expanded),
        symbol: expanded
              ? i18n.t('components.widgets.description_lessText')
              : i18n.t('components.widgets.description_moreText')
      }}
    >
      {text}
    </Paragraph>
  );
}
